import { useQuery } from '@tanstack/react-query';

import { PricingPlanCap } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/pricing-plan-cap/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    planId: string;
    parkingId: string;
}

const queryFn = ({ planId, parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<PricingPlanCap>> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PRICING_PLAN_CAPS_RESOURCE, useQueryHook as useListPricingPlanCaps };
